import * as ng from 'angular';
import * as uib from 'angular-ui-bootstrap';
import * as _ from 'underscore';

import { EventObjectApi, NamedEventObject } from '..';

class EventObjectManagerController {
   static $inject = ['$q', 'dialogs'];

   constructor(
      private $q:ng.IQService,
      private dialogs
   ) { }

   data:NamedEventObject[];
   newItem:{name?:string} = {};

   modalInstance:uib.IModalInstanceService;
   resolve: {
      title:string;
      objectApi:EventObjectApi;
   }

   get title() { return this.resolve.title; }
   get objectApi() { return this.resolve.objectApi; }

   private refresh() {
      this.resolve.objectApi.list().then(data => this.data = data);
   }

   $onInit() {
      this.refresh();
   }

   remove(item) {
      this.dialogs.confirm('Are you sure you want to remove this item?').then(() => {
         this.objectApi.del(item.id).then(() => this.refresh());
      });
   }

   add() {
      if (this.newItem && this.newItem.name && this.newItem.name !== '') {
         this.objectApi.add(this.newItem.name).then(() => {
            this.newItem = {};
            this.refresh();
         });
      }
   }

   cancel() {
      this.modalInstance.dismiss();
   }

   save() {
      let promises = _.map(this.data, item => this.objectApi.update(item));
      this.$q.all(promises).then(() => this.modalInstance.close());
   }
}

ng.module('e360').component('eventObjectManager', {
   templateUrl: require('./event-object-manager.html'),
   controller: EventObjectManagerController,
   bindings: {
      modalInstance: '<',
      resolve: '<'
   }
});
